const getSearchTermFromQueryString = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('category')) {
    return urlParams.get('category');
  }
  return false;
};

const scrollToProduct = () => {
  let searchTerm = '';
  if (getSearchTermFromQueryString()) {
    searchTerm = getSearchTermFromQueryString();
  } else {
    return;
  }

  const $elem = $(`[data-product-category="${searchTerm}"]`, $('.CollectionGrid')).first();
  const offset = $elem.offset();

  $('html, body').animate(
    {
      scrollTop: offset.top - 60,
    },
    500,
    'linear'
  );
};

const getPreselectFromQueryString = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('preselect')) {
    return urlParams.get('preselect');
  }
  return false;
};

const getFilterExpandFromQueryString = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('expandfilter')) {
    return urlParams.get('expandfilter');
  }
  return false;
};

const showSearchByCan = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('showSearchByCan')) {
    if (document.getElementById('searchByCan') !== null) {
      const elem = document.getElementById('searchByCan');
      elem.click();

      $('html, body').animate(
        {
          scrollTop: elem.getBoundingClientRect().top - 70,
        },
        500,
        'linear'
      );
    } else {
      return false;
    }
  }
  return false;
};

const expandFilterSelectors = () => {
  let filterExpandToggle = '';
  if (getFilterExpandFromQueryString()) {
    filterExpandToggle = getFilterExpandFromQueryString();
  } else {
    return;
  }

  const $expand_elem = $('.filter-button .expand');
  if ($expand_elem.length > 0) {
    if (filterExpandToggle === 'no' || filterExpandToggle === '0') {
      $('.filter-button').trigger('click');
    }
  }
};

const preselectFilterValues = () => {
  let preselectParam = '';
  if (getPreselectFromQueryString()) {
    preselectParam = getPreselectFromQueryString();
  } else {
    // CLOSE FILTER MENU ON MOBILE IF NO PRESELECT PARAM
    if ($('.FilteredProductVariantGrid').length && $(window).width() < 666) {
      $('.filter-button').trigger('click');
    }
    return;
  }

  const arrParam = preselectParam.split(',');
  arrParam.forEach((param, index) => {
    console.log(index);
    console.log(param);
    $(`#${param}`).trigger('click');
  });
};

const isInRange = (element, min, max) => {
  return parseFloat(element) >= parseFloat(min) && parseFloat(element) <= parseFloat(max);
};

setTimeout(() => {
  scrollToProduct();
}, 500);

$('.filter-button').click((e) => {
  $('.CollectionGrid .ProductVariantTile:not(.hide)').each((j, tile) => {
    $(tile).addClass('Animate--animated');
  });

  e.preventDefault();

  if ($(window).width() < 768) {
    $('.filter-option').slideToggle('slow');
    $('.filter-values').slideToggle('slow');
  } else {
    $('.filter-values').slideToggle('slow');
  }

  $('#filter-arrow').toggleClass('expand');
  $('.resetFilter').toggleClass('show');

  const divElement = document.querySelector('.resetFilter');
  if (divElement.classList.contains('show')) {
    $('html, body').animate(
      {
        scrollTop: $('#sectionCollectionFilter').offset().top - 50,
      },
      0
    );

    $('#filterParentWrapper').removeClass('stickyFilter');
  } else {
    $('#filterParentWrapper').addClass('stickyFilter');
  }

  e.stopPropagation();
});

$('.filter-option').on('click', function (e) {
  if (e.target !== this) {
    return;
  }

  if ($(window).width() < 768) {
    $('.filter-option').slideToggle('slow');
    $('.filter-values').slideToggle('slow');
  }

  if ($(window).width() > 767) {
    $('.filter-values').slideToggle('slow');
    $('#filter-arrow').toggleClass('expand');
    $('.resetFilter').toggleClass('show');
  }
});

$('.filter-optiontitle').on('click', function (e) {
  if (e.target !== this) {
    return;
  }

  if ($(window).width() < 768) {
    $('.filter-option').slideToggle('slow');
    $('.filter-values').slideToggle('slow');
  }

  if ($(window).width() > 767) {
    $('.filter-values').slideToggle('slow');
  }

  $('#filter-arrow').toggleClass('expand');
  $('.resetFilter').toggleClass('show');
});

$('.resetFilter').on('click', () => {
  $('.filter-input').prop('checked', false);
  $('.filter-input').removeAttr('disabled');
  $('.filter-input').trigger('change');
});

let nameClicked = '';
$('.filter-input').on('click', (e) => {
  nameClicked = $(e.currentTarget).attr('name');
});

$('#filterDiv input').on('change', (evt) => {
  $('.CollectionGrid .ProductVariantTile').removeClass('hide');
  $('.CollectionGrid .ProductVariantTile:not(.hide)')
    .addClass('hide')
    .filter((ind, tile) => {
      let reset = true;
      let rtnData = false;
      let inProductLevel = true;

      if ($('[data-level="product"]:checked').length) {
        $('[data-level="product"]:checked').each((i, ele) => {
          if ($(ele).attr('name') === 'size') {
            const strippedSize = $(tile).attr('data-can-size');
            const sizeMin = $(ele).attr('data-size-min');
            const sizeMax = $(ele).attr('data-size-max');
            if (!isInRange(strippedSize, sizeMin, sizeMax)) {
              inProductLevel = false;
            }
          } else {
            const strippedDataTags = $(tile).attr('data-tags').replace(/-/g, '');
            const strippedElementVal = $(ele).val().replace(/-/g, '');
            const regExpElement = new RegExp(`\\b${strippedElementVal}\\b`, 'ig');

            if (!strippedDataTags.match(regExpElement)) {
              inProductLevel = false;
            }
          }
        });
        reset = false;
      } else {
        inProductLevel = true;
      }

      let inVariantLevel = false;
      if ($('[data-level="variant"]:checked').length) {
        $('[data-level="variant"]:checked').each((i, ele) => {
          const strippedDataFinish = $(tile).attr('data-filter-finish').replace(/-/g, '');
          const strippedDataOption2 = $(tile).attr('data-option2').replace(/-/g, '');
          const strippedElementVal = $(ele).val().replace(/-/g, '');
          const regExpElement = new RegExp(`\\b${strippedElementVal}\\b`, 'ig');

          if (strippedDataFinish.match(regExpElement) || strippedDataOption2.match(regExpElement)) {
            inVariantLevel = true;
          }
        });
        reset = false;
      } else {
        inVariantLevel = true;
      }

      if (reset) {
        return true;
      }

      rtnData = inProductLevel && inVariantLevel;

      return rtnData;
    })
    .removeClass('hide');

  if ($('.filter-input:not(:checked)').length) {
    $('.filter-input:not(:checked)').each((i, input) => {
      let shouldDisable = true;
      if ($(input).attr('data-level') === 'variant') {
        $('.CollectionGrid .ProductVariantTile:not(.hide)').each((k, tile) => {
          const strippedInputVal = $(input).val().replace(/-/g, '');
          const strippedDataFinish = $(tile).attr('data-filter-finish').replace(/-/g, '');
          const strippedDataOption2 = $(tile).attr('data-option2').replace(/-/g, '');
          const regExpElement = new RegExp(`\\b${strippedInputVal}\\b`, 'ig');

          if (strippedDataFinish.match(regExpElement) || strippedDataOption2.match(regExpElement)) {
            shouldDisable = false;
          }
        });
      } else {
        $('.CollectionGrid .ProductVariantTile:not(.hide)').each((j, tile) => {
          if ($(input).attr('name') === 'size') {
            const strippedSize = $(tile).attr('data-can-size');
            const sizeMin = $(input).attr('data-size-min');
            const sizeMax = $(input).attr('data-size-max');
            if (isInRange(strippedSize, sizeMin, sizeMax)) {
              shouldDisable = false;
            }
          } else {
            const strippedInputVal = $(input).val().replace(/-/g, '');
            const strippedDataTags = $(tile).attr('data-tags').replace(/-/g, '');
            const regExpElement = new RegExp(`\\b${strippedInputVal}\\b`, 'ig');

            if (strippedDataTags.match(regExpElement)) {
              shouldDisable = false;
            }
          }
        });
      }
      $(input).prop('disabled', shouldDisable);
    });
  }
});

$('[data-search-by-can-btn]').on('click', () => {
  $('.CollectionSearchByCan .FilteredProductVariantGrid').show();
  $('.CollectionSearchByCan').toggleClass('hide');
});

preselectFilterValues();
expandFilterSelectors();
showSearchByCan();
